import { Col, Row } from "antd";
import React from "react";
import BookItem from "./book-item";
import { IrsadulHacDescription, IrsadulHacSummaryDescription } from "./books-descriptions/irsadul-hac-description";
import { SemayaYolculukDescription, SemayaYolculukSummaryDescription } from "./books-descriptions/semaya-yolculuk-description";
import { IslaminHuccetiDescription, IslaminHuccetiSummaryDescription } from "./books-descriptions/islamin-hucceti";
import { IrsadusSemaDescription, IrsadusSemaSummaryDescription } from "./books-descriptions/irsadus-sema-description";
import { MetafizikBoyutuDescription, MetafizikBoyutuSummaryDescription } from "./books-descriptions/metafizik-boyutu";
import { AllahinHidayetGunesiDescription, AllahinHidayetGunesiSummaryDescription } from "./books-descriptions/allahin-hidayet-gunesi";
import { Sohbetler1Description, Sohbetler1SummaryDescription } from "./books-descriptions/sohbetler-1";
import { Sohbetler2Description, Sohbetler2SummaryDescription } from "./books-descriptions/sohbetler-2";
import IrsadulHacc from '../../assets/books/kapaklar/irsadul-hacc.jpg';
import AskaMeskeSemayaYolculuk from '../../assets/books/kapaklar/aska-meske-semaya-yolculuk.jpg';
import IslaminHucceti from '../../assets/books/kapaklar/islam-hucceti.jpg';
import IrsadulSema from '../../assets/books/kapaklar/irsadul-sema.jpg';
import MetafizikBoyutu from '../../assets/books/kapaklar/allahin-metafizik-boyutu.jpg';
import AllahinHidayetGunesi from '../../assets/books/kapaklar/allahin-hidayet-gunesi.jpg';
import Sohbetler1 from '../../assets/books/kapaklar/sohbetler_1_new.jpg';
import Sohbetler2 from '../../assets/books/kapaklar/sohbetler_2_new.jpg';
import SemaGuide from '../../assets/books/kapaklar/sema-guide.jpg';
import { SemaGuideDescription, SemaGuideSummaryDescription } from "./books-descriptions/sema-guide";
import "./books.scss";


interface BooksProps {

}
interface BooksState {
    Change: boolean;
}

class Books extends React.Component<BooksProps, BooksState> {
    constructor(props: any) {
        super(props);
        this.state = {
            Change: true
        };
    }
    render() {
        return (
            <div className="books">
                <Row>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={IrsadulHacc}
                            detailedDescription={<IrsadulHacDescription />}
                            summaryDescription={<IrsadulHacSummaryDescription />}
                            title="İRŞAD-ÜL HACC"
                            imageTitle="İrşadül Hacc"
                            bookLink="https://www.kitapyurdu.com/kitap/irsadul-hacc/646892.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={AskaMeskeSemayaYolculuk}
                            detailedDescription={<SemayaYolculukDescription />}
                            summaryDescription={<SemayaYolculukSummaryDescription />}
                            title="AŞKA, MEŞKE SEMAYA YOLCULUK"
                            imageTitle="Aşka Meşke Semaya Yolculuk"
                            bookLink="https://www.kitapyurdu.com/kitap/aska-meske-ve-semaya-yolculuk/646891.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={IslaminHucceti}
                            detailedDescription={<IslaminHuccetiDescription />}
                            summaryDescription={<IslaminHuccetiSummaryDescription />}
                            title="İSLAM'IN HÜCCETİ"
                            imageTitle="İslam'ın Hücceti"
                            bookLink="https://www.kitapyurdu.com/kitap/islamin-hucceti/646893.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={IrsadulSema}
                            detailedDescription={<IrsadusSemaDescription />}
                            summaryDescription={<IrsadusSemaSummaryDescription />}
                            title="İRŞAD-ÜS SEMA"
                            imageTitle="İrşadüs Sema"
                            bookLink="https://www.kitapyurdu.com/kitap/irsadussema/650664.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={MetafizikBoyutu}
                            detailedDescription={<MetafizikBoyutuDescription />}
                            summaryDescription={<MetafizikBoyutuSummaryDescription />}
                            title="ALLAH'IN VARLIKLARININ METAFİZİK BOYUTU (İki Cilt)"
                            imageTitle="Allah'ın Varlıklarının Metafizik Boyutu"
                            bookLink="https://www.kitapyurdu.com/kitap/allahin-varliklarinin-metafizik-boyutu-1/650665.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={AllahinHidayetGunesi}
                            detailedDescription={<AllahinHidayetGunesiDescription />}
                            summaryDescription={<AllahinHidayetGunesiSummaryDescription />}
                            title="ALLAH'IN HİDAYET GÜNEŞİNİN DOĞMASI"
                            imageTitle="Allah'ın Hidayet Güneşinin Doğması"
                            bookLink="#"
                            isBookMarkVisible={false}
                        />
                    </Col>
                </Row>

                <Row>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={Sohbetler1}
                            detailedDescription={<Sohbetler1Description />}
                            summaryDescription={<Sohbetler1SummaryDescription />}
                            title="SOHBETLER-1"
                            imageTitle="Sohbetler 1"
                            bookLink="https://www.kitapyurdu.com/kitap/guzel-ahlak-huy-gonul-karakter-mizac-hikmet-ve-sirlari-sohbetler-1/525143.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                    <Col span={24} md={12}>
                        <BookItem
                            coverImage={Sohbetler2}
                            detailedDescription={<Sohbetler2Description />}
                            summaryDescription={<Sohbetler2SummaryDescription />}
                            title="SOHBETLER-2"
                            imageTitle="Sohbetler 2"
                            bookLink="https://www.kitapyurdu.com/kitap/madde-ve-mananin-ibadet-sekli-hikmet-ve-sirlari-sohbetler-2/525144.html"
                            isBookMarkVisible={true}
                        />
                    </Col>
                </Row>

                <Row>
                    <div style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <BookItem
                            coverImage={SemaGuide}
                            detailedDescription={<SemaGuideDescription />}
                            summaryDescription={<SemaGuideSummaryDescription />}
                            title="THE SEMA GUIDE"
                            imageTitle="Sohbetler 1"
                            bookLink={null}
                            isBookMarkVisible={false}
                        />
                    </div>
                </Row>
            </div>
        );
    }
}

export default Books;